
const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData = false;
const setObj = obj => setData ? ({ ...obj }) : ({});

export const InitPage = 0;

const catalogsDefault = {
    paymentFrequency: [],
    vehicleUse: [],
    vehicleStatus: [],
    brand: [],
    model: [],
    year: [],
    deductible: [],
    device: [],
    coverages: [],
    rates: [],
    planConfig:[]
}


const pricingDefault = {
    itipopol: 'I',
    VigenciaPol: 'A',
    ncuotas: 1,
    marca: 0,
    modelo: -1,
    anio: 0,
    auTipo: 0,
    auCategoria: 0,
    usoo: 1,
    nasiento: 0,
    valn: 0,
    suma: 0,
    valnreal: 0,
    GPS: 0,
    dedu: 0,
    rsat: 1,
    auNuevo: 0,
    auNumPasajeros: 0,
    auValorNuevo: 0,
    showDialogFail: false
};

const CoopenaeAutoMochaded = isDevelopment ? {
    firstName: 'Eddy Antonio',
    lastName: 'Ortiz Amador',
    typeId: '1',
    identificationNumber: '',
    cellphoneNumber: '',
    mail: 'eortiza@lafise.com'
} : {};

export const CoopenaeAutoDefault = {

    init: false,
    planId: 0,
    firstName: '',
    lastName: '',
    typeId: '',
    identificationNumber: '',
    cellphoneNumber: '',
    mail: '',
    currency: '',
    paymentFrequency: '',
    vehicleUse: '',
    vehicleStatus: '',
    brand: '',
    brandName: '',
    model: '',
    modelName: '',
    year: '',
    deductible: '',
    vehicleValue: '',
    device: '',
    bonus:0,
    desc:0,
    bonus2:0,
    pDesc:0,
    tax:0,
    financing:0,
    total: 0,
    catalogs: { ...catalogsDefault },
    pricing: { ...pricingDefault },
    message: '',
    isSaved: false,
    isError: false,
    isDatasheet: false,
    acceptTerm: false,
    requestNumber: '00000',
    setCatalogs: (obj) => { },
    setPricing: (obj) => { },
    ...setObj(CoopenaeAutoMochaded)
}

export const buildPricingData = (CoopenaeAuto) => {
    let data = {
        //...CoopenaeAuto.pricing,
        cate: CoopenaeAuto.pricing.auCategoria,
        nasiento: CoopenaeAuto.pricing.auNumPasajeros,
        suma: CoopenaeAuto.pricing.valn,
        modelo: CoopenaeAuto.model,
        marca: CoopenaeAuto.brand,
        anio: CoopenaeAuto.year,
        usoo: CoopenaeAuto.vehicleUse,
        codigo2: 0,
        codigo5: 0,
        codigo8: 0,
        codigo12: 0,
        itipopol: 'I',
        VigenciaPol: 'A',
        dedu: CoopenaeAuto.deductible,
        valn: CoopenaeAuto.vehicleValue,
        rsat: CoopenaeAuto.device
    }

    CoopenaeAuto.catalogs.coverages.sumInsureds.map((item) =>{
        data[`CobSA${item.id}`] = item.value;
    });

    let coverageIdsStr = "[";
    CoopenaeAuto.catalogs.coverages.coverages.forEach((item) => {
        data[`Cob${item.idCob}`] = 1;
        coverageIdsStr = coverageIdsStr + `${item.idCob},`;
    });
    coverageIdsStr = coverageIdsStr.substring(0, coverageIdsStr.length - 1) + "]";
    data["coverageIds"] = coverageIdsStr;
    return data;
}



const isOldVh = (anio) => {
    const d = new Date();
    let year = d.getFullYear();
    return anio != null && (year - Number.parseInt(anio)) >= 15
}